import angular from 'angular';
import uirouter from 'angular-ui-router';
import routing from './routes';

import PhotoManagerController from './PhotoManagerController';
// import angularFileUpload from 'angular-file-upload';
// import photoGallery from '../../directives/photoGallery';
// import 'ng-img-crop/compile/minified/ng-img-crop.js';
// import 'ng-img-crop/compile/minified/ng-img-crop.css';


import panel from '../../services';

export default angular.module('app.photoManager', [
        uirouter,
        panel,
        // 'angularFileUpload',
        // photoGallery,
        // 'ngImgCrop'
    ])
    .config(routing)
    .controller('PhotoManagerController', PhotoManagerController)
    .name;



// WEBPACK FOOTER //
// ./src/app/features/photo-manager/index.js